import React from 'react';
import type { IconButtonProps } from '@oneaudi/unified-web-components';
import { IconButton } from '@oneaudi/unified-web-components';
import styled from 'styled-components';

type ArrowButtonProps = Omit<IconButtonProps, 'icon' | 'size'> & {
  direction: 'left' | 'right'; // Define the direction prop as either 'left' or 'right'
  arialabel: string;
  variant: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const ArrowButton: React.FC<ArrowButtonProps> = ({
  direction,
  disabled,
  variant,
  onClick,
  arialabel,
}) => {
  return (
    <StyledButton
      disabled={disabled}
      data-testid={`arrow-button-${direction}`}
      size="sm"
      variant={variant}
      icon={direction === 'left' ? 'back' : 'forward'}
      onClick={onClick ?? (() => {})}
      aria-label={arialabel}
    />
  );
};

const StyledButton = styled(IconButton)<{ disabled?: boolean }>`
  @media (min-width: ${(props) => props.theme.breakpoints.md}px) {
    background: none;
    border: none;
    box-shadow: none;
    display: block;
  }

  // I know this is normally a no go, but otherwise the arrows still shows up on mobile somehow
  @media (max-width: ${(p) => p.theme.breakpoints.md - 1}px) {
    display: none !important;
  }
`;

export default ArrowButton;
